import React from 'react'
import classes from "../Footer/footer.module.css";

function footer() {
  return (
    <div className={classes.footer_main}>
        <div className={classes.footer_title}> © 2023 Ravisankar Bharadwaj Ammanamanchi</div>

    </div>
    )
}

export default footer